;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export default function AcademyPath() {
  return (
    <svg width="123" height="124" viewBox="0 0 123 124" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.1702 72.4302H1.5V93.3003H28.1702V72.4302Z"
        stroke="#A7DADB"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.0474 122L20.2986 93.2998" stroke="#64348C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M36.3788 56.8999L52.1724 65.4199" stroke="#64348C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M46.8354 122V111.57H73.5057V85.4797H97.4978V59.3896H121.5"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.5063 21.1299V24.3601C33.5063 29.3001 29.6831 33.3001 24.5719 33.3001H20.1763V19.8999"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4985 20.26C22.8346 20.26 27.8947 15.83 29.5303 13.48"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.8314 12.4299C38.8314 7.20993 32.2687 2 24.1623 2C16.0559 2 9.49311 7.99989 9.49311 15.3899V26.78C9.49311 29.71 7.90865 30.94 6.82507 32"
        stroke="#64348C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M53.5004 103.09L51.0061 87.22L36.1734 68.5301V50.2701C36.1734 42.4401 22.2095 33.2901 20.1753 33.3101C15.197 33.3101 9.51331 39.51 9.51331 43.74V72.44"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M20.1658 49.1201L20.2476 72.4299" stroke="#64348C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.1658 49.1201L20.2476 72.4299" stroke="#64348C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
